import { Button, Select } from "@mantine/core";
const themeObject = {
  /** Put your mantine theme override here */
  // fontFamily: "Open Sans, sans-serif",
  primaryColor: "cyan",
  black: "#000",
  white: "#fff",
  background: {
    dark: "#000",
    light: "#f7f8f8",
  },
  navbar: {
    background: {
      dark: "#000",
      light: "#fff",
    },
  },

  components: {
    Select: Select.extend({
      defaultProps: {
        checkIconPosition: "right",
        // variant: "outline",
      },
    }),

    Calendar: {
      defaultProps: {
        firstDayOfWeek: 0,
      },
    },
  },

  //   components: {
  //     Button: Button.extend({
  //       defaultProps: {
  //         color: "orange",
  //         // variant: "outline",
  //       },
  //     }),
  //   },
};

export default themeObject;
